import React, { useCallback } from "react";
import { Row, Col } from "react-bootstrap";
import OrganizerPillSelect from "../components/OrganizerPillSelect";
import { CAMPOS_WHATSAPP_RESENA, HORAS_DESPUES_RESENA, usePuedeCrearPlantillas } from "./recordatorios";
import CanalWhatsapp, { CanalEmail, CanalPush } from "./CanalWhatsapp";

/* Review request block of the three verticals' policy forms (Beauty, courts, tables), right after the reminders. It
   sits in a full-width column of the form's Row. `resena` is the form value `{ enabled, hoursAfter, whatsapp }`
   (resenaDeVenue) and `onChange(resena)` receives the whole updated value, so the form keeps it in one field.
   The WhatsApp channel has its own workspace and template and offers the review link as template data.
   `onAntesDeIrAChat` runs when the Zoco Chat link is clicked, so the form can keep its unsaved edits (borradorPoliticas). */

const OPCIONES = HORAS_DESPUES_RESENA.map((value) => ({ value, label: `${value} h después` }));

const PedidoResenaAjustes = ({ resena, onChange, local, errorWhatsapp, onAntesDeIrAChat, volver }) => {
  const puedeCrear = usePuedeCrearPlantillas();
  const { enabled, hoursAfter, whatsapp, push } = resena;
  const cambiarWhatsapp = useCallback((wa) => onChange({ ...resena, whatsapp: wa }), [onChange, resena]);

  return (
    <Row className="g-4">
      <Col md={6}>
        <div className="zr-field">
          <span className="zr-field__label">Pedido de reseña</span>
          <input
            type="checkbox"
            className="zr-switch"
            aria-label="Pedido de reseña"
            checked={Boolean(enabled)}
            onChange={() => onChange({ ...resena, enabled: !enabled })}
          />
          <small style={{ color: "#6b7280", fontSize: 12 }}>Se envía solo a las reservas marcadas como Presente.</small>
        </div>
      </Col>
      {enabled && (
        <Col md={6}>
          <div className="zr-field">
            <span id="resena-horas-label" className="zr-field__label">Enviar</span>
            <OrganizerPillSelect
              id="resena-horas"
              labelledBy="resena-horas-label"
              value={hoursAfter}
              onChange={(val) => onChange({ ...resena, hoursAfter: Number(val) })}
              options={OPCIONES}
            />
            <small style={{ color: "#6b7280", fontSize: 12 }}>Se cuenta desde que termina el turno.</small>
          </div>
        </Col>
      )}
      {enabled && (
        <Col md={12}>
          <div className="zr-field">
            <span id="resena-canales-label" className="zr-field__label">Canales del pedido de reseña</span>
            <div className="rwa-canales" role="group" aria-labelledby="resena-canales-label">
              <CanalEmail texto="Le llega al email que el cliente dejó al reservar, si dejó uno." />
              <CanalWhatsapp
                whatsapp={whatsapp}
                onChange={cambiarWhatsapp}
                local={local}
                error={errorWhatsapp}
                puedeCrear={puedeCrear}
                onAntesDeIrAChat={onAntesDeIrAChat}
                volver={volver}
                campos={CAMPOS_WHATSAPP_RESENA}
                idBase="rwa-resena"
                etiqueta="Pedido de reseña por WhatsApp"
                pedido="resena"
              />
              <CanalPush push={push} onChange={(p) => onChange({ ...resena, push: p })} etiqueta="Pedido de reseña por notificación en la app" tipo="review" />
            </div>
          </div>
        </Col>
      )}
    </Row>
  );
};

export default PedidoResenaAjustes;
